import SquareIcon from '@/assets/icons/square.svg?react'
import { useWavesurfer } from '@wavesurfer/react'
import clsx from 'clsx'
import { memo, useEffect, useRef } from 'react'
import RecordPlugin from 'wavesurfer.js/dist/plugins/record.esm.js'
import { formatTime } from './AudioRecordingTask'

type RecordingStateRecordingProps = {
  seconds: number
  onStopRecording: () => void
}

// eslint-disable-next-line react/display-name
export const RecordingStateRecording = memo(({ onStopRecording }: RecordingStateRecordingProps) => {
  const playerRef = useRef<HTMLDivElement>(null)
  const recordPluginInstanceRef = useRef<RecordPlugin | null>(null)

  const { wavesurfer } = useWavesurfer({
    container: playerRef,
    cursorColor: 'transparent',
    cursorWidth: 2,
    dragToSeek: false,
    duration: 10,
    height: 40,
    waveColor: '#E40027',
    progressColor: '#ffffff',
    autoplay: false,
    barWidth: 3,
    barHeight: 4
  })

  useEffect(() => {
    let recordPluginInstance: RecordPlugin | null = null
    const init = async () => {
      recordPluginInstance = RecordPlugin.create({ scrollingWaveform: true, renderRecordedAudio: true })
      recordPluginInstanceRef.current = recordPluginInstance
      wavesurfer?.registerPlugin(recordPluginInstance)

      if (!recordPluginInstanceRef.current?.isRecording()) {
        await recordPluginInstanceRef.current?.startRecording()
      }
    }
    if (wavesurfer) init()

    return () => {
      if (recordPluginInstance) {
        recordPluginInstance?.destroy()
      }
    }
  }, [wavesurfer])

  return (
    <div className="flex w-full flex-col items-center gap-2" style={{ animation: 'nectar-scale-in 0.3s ease-out' }}>
      <div className="relative flex items-center justify-center" style={{ width: 96, height: 96 }}>
        <div
          className="bg-red absolute inset-0 rounded-full"
          style={{ animation: 'nectar-pulse-ring 2s ease-out infinite' }}
        />
        <div
          className="bg-red absolute inset-0 rounded-full opacity-0"
          style={{ animation: 'nectar-pulse-ring 2s ease-out infinite 0.8s' }}
        />
        <button
          type="button"
          onClick={async () => {
            await onStopRecording()
            recordPluginInstanceRef.current?.stopRecording()
          }}
          className="bg-red relative z-10 flex size-20 items-center justify-center rounded-full text-white shadow-lg transition-all duration-200 hover:scale-105"
        >
          <SquareIcon className="h-8" />
        </button>
      </div>
      <div className="text-body2-regular text-gray-90 flex items-center gap-3">{formatTime(0)}</div>
      <div className={clsx('h-10 w-full flex-1')} ref={playerRef}></div>
    </div>
  )
})
